var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9988 20.9998L15.8018 15.8028M15.8018 15.8028C17.2084 14.3962 17.9986 12.4885 17.9986 10.4993C17.9986 8.51011 17.2084 6.60238 15.8018 5.19581C14.3953 3.78923 12.4875 2.99902 10.4983 2.99902C8.50913 2.99902 6.6014 3.78923 5.19483 5.19581C3.78825 6.60238 2.99805 8.51011 2.99805 10.4993C2.99805 12.4885 3.78825 14.3962 5.19483 15.8028C6.6014 17.2094 8.50913 17.9996 10.4983 17.9996C12.4875 17.9996 14.3953 17.2094 15.8018 15.8028Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.21705e03061d421639e2f03ff820bdfe.svg";
export { ForwardRef as ReactComponent };